import classNames from "classnames";
import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon/Icon.tsx";

export const EmptyState = ({
  iconName,
  title,
  header,
  description,
  className,
  children,
}: {
  iconName: IconName;
  title: string;
  header?: string;
  description?: string;
  className?: string;
  children?: ReactNode;
}) => (
  <div
    className={classNames(
      "flex-col items-center text-center gap-400",
      className,
    )}
  >
    {/*
      Because of the rotation applied in the component below,
      we need to add this empty div to slightly push everything down
      and thus make sure it doesn't overlap with other UI elements.
    */}
    <div className="h-0" />
    <div className="h-[82px] w-[70px] relative">
      <div
        className="absolute inset-0 bg-surface-hover bg-surface-primary-hover rounded-300"
        style={{ transform: "rotate(15deg) translate(5px, 0px)" }}
      />
      <div
        className="absolute inset-0 flex-col border p-050 rounded-300 bg-white"
        style={{ transform: "rotate(-15deg) translate(-5px, 0px)" }}
      >
        <div className="flex-col gap-200 py-300 items-center rounded-200 bg-surface-primary-hover">
          <Icon name={iconName} size="xl" />
          <div className="text-primary label-md-default">{title}</div>
        </div>
      </div>
    </div>
    <div className="flex-col items-center">
      {header && <div className="text-primary label-lg-semibold">{header}</div>}
      {description && (
        <div className="text-secondary label-lg-default">{description}</div>
      )}
    </div>
    {children}
  </div>
);
